module.exports = __webpack_public_path__ + "media/country_flags/tl-c3f7abf3.png";